<template>
  <CSidebar 
    fixed 
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <h1>SAKSHAM</h1>
      <!--<CIcon 
        class="c-sidebar-brand-full" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 556 134"
      />
      <CIcon 
        class="c-sidebar-brand-minimized" 
        name="logo" 
        size="custom-size" 
        :height="35" 
        viewBox="0 0 110 134"
      />-->
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="navbar"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
export default {
  name: 'TheSidebar',
  data () {
    return {
		Role_Id : JSON.parse(localStorage.getItem("user"))[0].Role_Id,
		navbar:[],
	}
  },
  mounted () {
	//console.log(this.Role_Id);	
	var userRules=JSON.parse(localStorage.getItem("RoleWiseModules"));
	//console.log(userRules);
	// default deshbord set
	var navArr=[
	  {
		_name: 'CSidebarNav',
		_children: [
		  {
			_name: 'CSidebarNavItem',
			name: 'Dashboard',
			to: '/dashboard',
			icon: 'cil-speedometer',
			// badge: {
			//   color: 'primary',
			//   text: 'NEW'
			// }
		  }			
		]
	  }
	];
	// default deshbord set over
	if(this.Role_Id==1){ //Admin
		//console.log(navArr[0]._children);
		navArr[0]._children.push(
			  {
				_name: 'CSidebarNavItem',
				name: 'Manage Roles',
				to: '/role_lists',
				icon: 'cil-industry',
			  },			  
			  {
				_name: 'CSidebarNavItem',
				name: 'Manage Modules',
				to: '/manage_modules',
				icon: 'cil-star',
			  },
			  {
				_name: 'CSidebarNavItem',
				name: 'Manage Assign Module',
				to: '/manage_assign_module',
				icon: 'cil-task',
			  },
			  {
				_name: 'CSidebarNavItem',
				name: 'Manage Users',
				to: '/manage_users',
				icon: 'cil-user',
			  },
			  {
				_name: 'CSidebarNavItem',
				name: 'Feedback',
				to: '/manage_feedback_module',
				icon: 'cil-comment-square',
			  },
			  {
				_name: 'CSidebarNavItem',
				name: 'Feedback Answer',
				to: '/manage_feedback_answer_module',
				icon: 'cil-comment-square',
			  },
			  {
				_name: 'CSidebarNavItem',
				name: 'Email Template',
				to: '/email_template',
				icon: 'cil-envelope-closed',
			  },
			  {
				_name: 'CSidebarNavItem',
				name: 'Push Notifications',
				to: '/push_notification',
				icon: 'cil-bell',
		      },	
			  /*{
				_name: 'CSidebarNavItem',
				name: 'Manage Waste',
				to: '/manage_wastes',
				icon: 'cil-drop',
			  },
			  {
				_name: 'CSidebarNavItem',
				name: 'Marketing Dashboard',
				to: '/marketing_dashboard',
				icon: 'cil-drop',
			  }*/
			  );
	}else{
		
		var modulefind = userRules.find(function(jsonitem, f){
			//console.log(jsonitem.Slug);
			if(jsonitem.Slug=='roles_list'){
				navArr[0]._children.push({
					_name: 'CSidebarNavItem',
					name: 'Manage Roles',
					to: '/role_lists',
					icon: 'cil-industry',
				});
			}else if(jsonitem.Slug=='modules_list'){
				navArr[0]._children.push({
					_name: 'CSidebarNavItem',
					name: 'Manage Modules',
					to: '/manage_modules',
					icon: 'cil-star',
				});
			}else if(jsonitem.Slug=='assign_modules list'){
				navArr[0]._children.push({
					_name: 'CSidebarNavItem',
					name: 'Manage Assign Module',
					to: '/Manage_assign_module',
					icon: 'cil-task',
				});
			}else if(jsonitem.Slug=='user_list'){
				navArr[0]._children.push({
					_name: 'CSidebarNavItem',
					name: 'Manage Users',
					to: '/manage_users',
					icon: 'cil-user',
				});
			}else if(jsonitem.Slug=='waste_list'){
				navArr[0]._children.push({
					_name: 'CSidebarNavItem',
					name: 'Manage Waste',
					to: '/manage_wastes',
					icon: 'cil-drop',
				});
			}else if(jsonitem.Slug=='payment_advice'){
				navArr[0]._children.push({
					_name: 'CSidebarNavItem',
					name: 'Payment Advice',
					to: '/payment_advices',
					icon: 'cil-drop',
				});
			}else if(jsonitem.Slug=='marketing_dashboard'){
				navArr[0]._children.push({
					_name: 'CSidebarNavItem',
					name: 'Marketing Dashboard',
					to: '/marketing_dashboard',
					icon: 'cil-drop',
				});
			}else if(jsonitem.Slug=='waste_lifting_list'){
				navArr[0]._children.push({
					_name: 'CSidebarNavItem',
					name: 'Manage Waste Lifting',
					to: '/waste_lifting_lists',
					icon: 'cil-drop',
				});
			}			
		});		
	}
	this.navbar=navArr;
	//console.log(this.navbar);		
  },	 
  computed: {	
    show () {
		
		return this.$store.state.sidebarShow 
    },
    minimize () {
      return this.$store.state.sidebarMinimize 
    }
  }
}
</script>
